import { DOWN_AND_DISTANCE, FIELD_ZONE } from '../constants/filters';
import { DOWN_AND_DISTANCE_KEY, FIELD_ZONE_KEY } from './selectors/filters';
import { getFilters, saveFilters } from '../api/filters';
import { isReadyForInsert } from '../utils/filters';

export const ADD_FILTERS = 'ADD_FILTERS';
export const ADD_FILTER_FORMULA_ID = 'ADD_FORMULA_ID';
export const UPDATE_DOWN_DISTANCE = 'UPDATE_DOWN_DISTANCE';
export const UPDATE_FIELD_ZONE = 'UPDATE_FIELD_ZONE';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';

export default function reducer(state = {}, action) {
  switch (action.type) {
    case ADD_FILTERS:
      return action.payload;
    case UPDATE_DOWN_DISTANCE:
      return {
        ...state,
        [DOWN_AND_DISTANCE]: action.payload,
      };
    case UPDATE_FIELD_ZONE:
      return {
        ...state,
        [FIELD_ZONE]: action.payload,
      };
    case CLEAR_FILTERS:
      return {};
    default:
      return state;
  }
}

export function getAllFilters(groupId) {
  return async (dispatch) => {
    const filters = await getFilters(groupId);

    dispatch({
      type: ADD_FILTERS,
      payload: filters,
    });
  };
}

export function addFilters(payload) {
  return {
    type: ADD_FILTERS,
    payload,
  };
}

export function updateDownDistance(FilterFormulaId, GroupId, FilterData) {
  return (dispatch) => {
    const isReady = isReadyForInsert(DOWN_AND_DISTANCE_KEY, FilterData[FilterData.length - 1]
      || []);
    if (isReady) saveFilters({ FilterFormulaId, GroupId, FilterData });

    dispatch({
      type: UPDATE_DOWN_DISTANCE,
      payload: FilterData,
    });
  };
}

export function updateFieldZone(FilterFormulaId, GroupId, FilterData) {
  return (dispatch) => {
    const isReady = isReadyForInsert(FIELD_ZONE_KEY, FilterData[FilterData.length - 1] || []);

    if (isReady) saveFilters({ FilterFormulaId, GroupId, FilterData });

    dispatch({
      type: UPDATE_FIELD_ZONE,
      payload: FilterData,
    });
  };
}

export function addFormulaId(payload) {
  return {
    type: ADD_FILTER_FORMULA_ID,
    payload,
  };
}
